/* eslint-disable no-undef */
/*Framework Imports */
import React, { useState } from "react";

/*Component Declaration*/
const Timer = (props) => {
  //State Variables
  const [remainingTime, setRemainingTime] = useState({
    minutes: "00",
    seconds: "00",
  });
  const [firstTime, setFirstTime] = useState(true);
  const validationDate = props.validationDate;
  const setExpiredForm = props.setExpiredForm;

  //Methods
  const calculateRemainingTime = (validationDate) => {
    const now = new Date();
    validationDate = new Date(validationDate);
    const seconds =
      config.expirationTimeMinutes * 60 -
      Math.abs(now.getTime() - validationDate.getTime()) / 1000;
    if (seconds > 0 && seconds < config.expirationTimeMinutes * 60) {
      const minutesDifference = Math.floor(seconds / 60);
      const secondsDifference = (seconds / 60 - Math.floor(seconds / 60)) * 60;
      setRemainingTime((prevState) => {
        return {
          minutes: String(minutesDifference).padStart(2, "0"),
          seconds: String(secondsDifference.toFixed(0)).padStart(2, "0"),
        };
      });
      setTimeout(() => {
        calculateRemainingTime(validationDate);
      }, 1000);
      if (firstTime) {
        setExpiredForm((prevState) => false);
        setFirstTime((prevState) => false);
      }
    } else {
      setExpiredForm((prevState) => true);
      setRemainingTime((prevState) => {
        return { minutes: "00", seconds: "00" };
      });
    }
  };

  //Set timeout to calculate remaining time
  if (validationDate !== "")
    setTimeout(() => {
      calculateRemainingTime(validationDate);
    }, 100);

  return (
    <span>
      {remainingTime.minutes}:{remainingTime.seconds}
    </span>
  );
};

export default Timer;
